import type { IUserPermissions } from 'src/models/permission/permission';

import axiosInstance, { endpoints } from 'src/lib/axios';

/**
 * 현재 사용자의 메뉴 권한 조회
 */
export const getUserPermissions = async (): Promise<IUserPermissions> => {
  const res = await axiosInstance.get<IUserPermissions>(endpoints.permission.me);
  return res.data;
};
